import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Play } from 'lucide-react';
import { Button } from './ui/button';

const PetMediaCarousel = ({ mediaItems }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!mediaItems || mediaItems.length === 0) {
    return (
      <div className="relative h-64 bg-gray-200 flex items-center justify-center">
        <p className="text-gray-500">No media available</p>
      </div>
    );
  }

  const goToPrevious = (e) => {
    e.stopPropagation();
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? mediaItems.length - 1 : prevIndex - 1
    );
  };

  const goToNext = (e) => {
    e.stopPropagation();
    setCurrentIndex((prevIndex) =>
      prevIndex === mediaItems.length - 1 ? 0 : prevIndex + 1
    );
  };

  const goToSlide = (index, e) => {
    e.stopPropagation();
    setCurrentIndex(index);
  };

  const currentMedia = mediaItems[currentIndex];

  return (
    <div className="relative h-64 overflow-hidden group">
      {/* Main Media Display */}
      <div className="w-full h-full">
        {currentMedia.type === 'video' ? (
          <div className="relative w-full h-full bg-black">
            <video
              src={currentMedia.url}
              controls
              className="w-full h-full object-contain"
              onClick={(e) => e.stopPropagation()}
            >
              Your browser does not support the video tag.
            </video>
            <div className="absolute top-2 left-2 bg-black/60 text-white px-2 py-1 rounded text-xs flex items-center">
              <Play className="w-3 h-3 mr-1" />
              Video
            </div>
          </div>
        ) : (
          <img
            src={currentMedia.url}
            alt={`Pet ${currentIndex + 1}`}
            className="w-full h-full object-contain bg-gray-100"
            onError={(e) => {
              e.target.src = '/placeholder-pet.jpg';
            }}
          />
        )}
      </div>

      {/* Navigation Arrows - Only show if more than 1 media item */}
      {mediaItems.length > 1 && (
        <>
          <Button
            variant="ghost"
            size="icon"
            className="absolute top-1/2 left-2 transform -translate-y-1/2 bg-white/80 hover:bg-white opacity-0 group-hover:opacity-100 transition-opacity duration-200"
            onClick={goToPrevious}
          >
            <ChevronLeft className="w-6 h-6" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            className="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/80 hover:bg-white opacity-0 group-hover:opacity-100 transition-opacity duration-200"
            onClick={goToNext}
          >
            <ChevronRight className="w-6 h-6" />
          </Button>
        </>
      )}

      {/* Media Counter */}
      <div className="absolute top-2 right-2 bg-black/60 text-white px-2 py-1 rounded text-xs">
        {currentIndex + 1} / {mediaItems.length}
      </div>

      {/* Dot Indicators - Only show if more than 1 media item */}
      {mediaItems.length > 1 && (
        <div className="absolute bottom-2 left-0 right-0 flex justify-center space-x-2">
          {mediaItems.map((_, index) => (
            <button
              key={index}
              onClick={(e) => goToSlide(index, e)}
              className={`w-2 h-2 rounded-full transition-all duration-200 ${
                index === currentIndex
                  ? 'bg-white w-6'
                  : 'bg-white/50 hover:bg-white/75'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      )}

      {/* Swipe Indicator */}
      {/* {mediaItems.length > 1 && (
        <div className="absolute bottom-8 left-0 right-0 flex justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200">
          <div className="bg-black/60 text-white px-3 py-1 rounded-full text-xs">
            Swipe or click arrows
          </div>
        </div>
      )} */}
    </div>
  );
};

export default PetMediaCarousel;
